import axios from "../../api/Interceptors"
import { history } from '../../helpers';
import { userConstants } from '../../store/actionTypes';
import { alertActions, donationActions } from './';
import { fundraiserAPIs, countriesAPIs, userAPIs, donationAPIs } from "../../api";
import TagManager from 'react-gtm-module';
import slugify from 'react-slugify';
import { SET_GOOD_LUCK_MESSAGES, SET_PRODUCTS } from "../actionTypes/FundraiserTypes";
import { WEB_URL } from "../../api/URLs";
import { DRAFT_PAGE, PROFILE_TABS, SINGLE_OWNER_PAGE, TEAM_PAGE } from "../../constants";

function getGoodLuckMessages(payload) {

    return async dispatch => {
        try {
            const response = await fundraiserAPIs.getPageMessages(payload);
            if (response.data.error) {
                return false;
            }
            if (response.data) {
                dispatch({
                    type: SET_GOOD_LUCK_MESSAGES,
                    response: response.data.data,
                    payloadOffset: payload.offset || 0
                })
            }
        }
        catch {
            return false;
        }
    };
}

function getAllFundRaiserPages(payload) {
    let is_search_request = 0;
    if (payload.search === 1) {
        is_search_request = 1;
    } else {
        is_search_request = 0;
    }

    if (payload.loadmore === 1) {
        is_search_request = 0;
    }
    return async dispatch => {
        try {
            const response = await fundraiserAPIs.getAllFundraisers(payload)
            dispatch(updateLoaderState(false));
            if (response.data) {
                if (is_search_request === 1) {
                    dispatch(changeFundRaiserPageList(response.data.data, 1));
                } else {
                    dispatch(changeFundRaiserPageList(response.data.data, 0));
                }
            }
        }
        catch {
            return false;
        }
    };
}

function getFundRaiserPage(fundraiser_slug, request_type = '') {
    return async dispatch => {
        try {
            const response = await fundraiserAPIs.getFundraiserDetails(fundraiser_slug);
            dispatch(updateLoaderState(false));
            if (response.data.error) {
                window.location.href = WEB_URL.PAGE_NOT_FOUND;
                return false;
            }
            if (response.data.success) {
                if (response.data.success.status === 4 && request_type === 'checkout_page') {
                    window.location.href = WEB_URL.PAGE_NOT_FOUND;
                    return false;
                }
                dispatch(changeFundRaiserPageDetail(response.data.success));
            }

        }
        catch {
            return false;
        }
    };
}

function getEventId() {
    return async dispatch => {
        try {
            const response = await fundraiserAPIs.getEventId();
            if (response.data.error) {
                alert(response.data.error);
                return false;
            }
            if (response.data) {
                dispatch(changeEventIdDetail(response.data));
            }
        }
        catch {
            return false;
        }
    };
}

function getMinMaxGoalRange(currency_id) {
    return async dispatch => {
        try {
            const response = await fundraiserAPIs.getCountryGoalRange(currency_id);
            if (response.data.error) {
                return false;
            }
            if (response.data) {
                dispatch(changeMinMaxGoalRangeDetail(response.data.data));
            }
        }
        catch {
            return false;
        }
    };
}

function createFundRaiserPage(payload) {
    return async dispatch => {
        try {
            const response = await fundraiserAPIs.createFundraiserPage(payload);
            dispatch(updateLoaderState(false));
            if (response.status === 201) {
                const { USER_PAGES, TEAM_PAGES } = PROFILE_TABS;
                dispatch(createFundRaiserInfo(response));

                if(response.data.data.status == DRAFT_PAGE)
                {
                    switch (Number(response.data.data.page_type)) {
                        case SINGLE_OWNER_PAGE:
                            window.location.href = WEB_URL.PROFILE(USER_PAGES);
                            break;
                            
                            case TEAM_PAGE:
                            window.location.href = WEB_URL.PROFILE(TEAM_PAGES);
                            break;
                    
                        default:
                            break;
                    }
                }
                
                else {
                    //dispatching on GTM below
                    TagManager.dataLayer({
                        dataLayer: {
                            "event": "fundraiserComplete"
                        }
                    });
                    window.location.href = WEB_URL.FUNDRAISER_DETAILS(response.data.data.event_id, slugify(response.data.data.page_title));
                }
                dispatch(fundRaiserPageAction.resetInitialState());
                await dispatch(alertActions.success("Fundraiser Page Created"));
                return;
            }
            else {
                if (response && response.data && response.data.error) {
                    dispatch(alertActions.error(response.data.error.toString()));
                } else {
                    console.log('Something went wrong !');
                }
                return;
            }

        }
        catch (error) {
            const errorMessage = error.response ? error.response.data.message : error.message;
            dispatch(alertActions.error(errorMessage));
        }
    }
}

function updateFundRaiserPage(payload, id) {
    return async dispatch => {
        try {
            const response = await fundraiserAPIs.updateFundraiserPage(id, payload);

            dispatch(updateLoaderState(false));

            if (response.status === 201) {
                const { USER_PAGES, TEAM_PAGES } = PROFILE_TABS;

                dispatch(createFundRaiserInfo(response));
                
                if(response.data.data.status == DRAFT_PAGE)
                {
                    switch (Number(response.data.data.page_type)) {
                        case SINGLE_OWNER_PAGE:
                            window.location.href = WEB_URL.PROFILE(USER_PAGES);
                            break;
                            
                            case TEAM_PAGE:
                                window.location.href = WEB_URL.PROFILE(TEAM_PAGES);
                            break;
                    
                        default:
                            break;
                    }
                }
                else {
                    window.location.href = WEB_URL.FUNDRAISER_DETAILS(response.data.data.event_id, slugify(response.data.data.page_title));
                }
                dispatch(alertActions.success("Fundraiser Page Updated"));
                return;
            }
            else {
                if (response.data && response.data.error) {
                    dispatch(updateLoaderState(false));
                    dispatch(alertActions.error(response.data.error.toString()));
                } else {
                    dispatch(alertActions.error('Something went wrong !'));
                }
                return;
            }
        }
        catch (error) {
            const errorMessage = error.response ? error.response.data.message : error.message;
            dispatch(updateLoaderState(false));
            dispatch(alertActions.error(errorMessage));
        }
    }
}

function onChangeProps(props, event) {
    return dispatch => {
        dispatch(handleOnChangeProps(props, event.target.value));
    }
}

function getListOfCampaigns(countryId) {
    return async dispatch => {
        try {
            const response = await fundraiserAPIs.getCampaignsList(countryId);
            dispatch(changeCampaignsList(response.data.data));
        }
        catch {
            return false;
        }
    };
}

function getListOfOccasions() {
    return async dispatch => {
        try {
            const response = await fundraiserAPIs.getOccasions();
            dispatch(changeOccasionsList(response.data.data));
        }
        catch {
            return false;
        }
    };
}

function getFundRaiserPageDefaultImages() {
    return async dispatch => {
        try {
            const response = await fundraiserAPIs.getFundraiserDefaultImage();
            dispatch(changeFundRaiserDefaultImageList(response.data.data));
        }
        catch {
            return false;
        }
    };
}

function getListOfCurrencies() {
    return async dispatch => {
        try {
            const response = await countriesAPIs.fetchAllCurrencies();
            dispatch(changeCurrenciesList(response.data.data));
        }
        catch {
            return false;
        }
    };
}

function getListOfCountries() {
    return async dispatch => {
        try {
            const response = await countriesAPIs.getAllCountries();
            dispatch(changeCountriesList(response.data.data));
        }
        catch {
            return false;
        }
    };
}

function getListOfCountriesWithoutPartners() {
    return async dispatch => {
        try {
            const response = await countriesAPIs.getCountriesWithoutPartners();
            dispatch(countriesWithoutPartners(response.data.data));
        }
        catch {
            return false;
        }
    };
}

function getListOfCountriesWithCurrencies() {
    return async dispatch => {
        try {
            dispatch(updateLoaderState(true));
            const response = await countriesAPIs.getCountriesWithCurrencies();
            await dispatch(changeCountriesWithCurrenciesList(response.data.data));
            dispatch(updateLoaderState(false));
        }
        catch {
            dispatch(updateLoaderState(false));
            return false;
        }
    };
}

function getProducts(countryId) {
    return async dispatch => {
        try {
            const response = await fundraiserAPIs.getProducts(countryId);
            if (response.data.error) {
                return false;
            }
            if (response.data.success) {
                dispatch({
                    type: SET_PRODUCTS,
                    response: response.data.success,
                })
            }
        }
        catch {
            return false;
        }
    };
}

function fetchUsersToInvite(payload) {
    return async dispatch => {
        try {
            const response = await userAPIs.getActiveUsers(payload);
            if (response && response.data && response.data.data) {
                dispatch(changeUsersWithoutLeadList(response.data.data));
            } else {
                let empty_data = [];
                dispatch(changeUsersWithoutLeadList(empty_data));
            }
        }
        catch {
            return false
        }
    };
}

function createTeamMember(payload) {
    return async dispatch => {
        try {
            await fundraiserAPIs.createTeamMember(payload);
            await dispatch(fundRaiserPageAction.getListOfTeamMembers(payload.fk_fundraiser_page));
        }
        catch {
            return false;
        }
    };
}

function removeTeamMember(payload) {
    return async dispatch => {
        try {
            await fundraiserAPIs.removeTeamMember(payload);
            dispatch(fundRaiserPageAction.getListOfTeamMembers(payload.fd_id));
            dispatch(alertActions.success("Removed Successfully"));
        }
        catch (error) {
            console.log("Something went wrong");
        }
    };
}

function getListOfTeamMembers(id) {
    return async dispatch => {
        try {
            const response = await fundraiserAPIs.getTeamMembers(id);
            dispatch(updateTeamMembers(response.data.data));
            dispatch(changeTeamMembersList(response.data.data));
        }
        catch {
            console.log("Something went wrong. Didn't get the list of team members.")
        }
    };
}

function getListOfTeamMembersWithPagination(id, status = -1, limit = 4, page_no) {
    return async dispatch => {
        try {
            const response = await fundraiserAPIs.getTeamMembersWithPagination(id, status, limit, page_no);
            await dispatch(changeTeamMembersPaginationList(response.data.data));
        }
        catch {
            console.log("Something went wrong. Didn't get the list of team members.")
        }
    };
}

function getListOfTeamMembersCount(id, status = -1) {
    return async dispatch => {
        try {
            const response = await fundraiserAPIs.getTeamMembersCount(id, status)
            dispatch(updateLoaderState(false));
            dispatch(changeTeamMembersListCount(response.data.data));
        }
        catch {
            console.log("Something went wrong. Didn't get team members count.");
        }
    };
}

function getTeamMemberDetails(id, fp_id) {
    return async dispatch => {
        try {
            const response = await fundraiserAPIs.getTeamMemberDetails(id, fp_id);
            dispatch(updateLoaderState(false));
            dispatch(TeamMemberList(response.data.data));
        }
        catch {
            console.log("Something went wrong. Didn't get the team member detail.");
        }
    };
}

function getListOfFundraiserPageDonors(id, limit, page_no) {
    return async dispatch => {
        try {
            const response = await fundraiserAPIs.getPageDonors(id, limit, page_no);
            dispatch(changeFundRaiserPageDonorList(response.data.data));
        }
        catch {
            console.log("Something went wrong. Didn't get the page donors.");
        }
    };
}

function getFundraiserRecentDonations(id, limit, offset) {
    return async dispatch => {
        try {
            const response = await fundraiserAPIs.getPageRecentDonations(id, limit, offset);
            dispatch(changeFundRaiserPageMonstRecentDonations(response.data.data, offset));
        }
        catch {
            console.log("Something went wrong. Didn't get page recent donations.");
        }
    };
}

function getFundraiserMostDonated(id, limit, offset) {
    return async dispatch => {
        try {
            const response = await fundraiserAPIs.getPageHighestDonations(id, limit, offset);
            dispatch(changeFundRaiserPageMonstDonations(response.data.data, offset));
        }
        catch
        {
            console.log("Something went wrong. Didn't get page highest donations.");
        }
    };
}

function getDonationCount(id) {
    return async dispatch => {
        try {
            const response = await fundraiserAPIs.getPageDonationsCount(id);
            dispatch(updateLoaderState(false));
            dispatch(changeDonationsListCount(response.data.data));
        }
        catch {
            console.log("Something went wrong. Didn't get the donations count.");
        }
    };
}

function getFundraisersCount() {
    return async dispatch => {
        try {
            const response = await fundraiserAPIs.getFundraisersCount();
            dispatch(changeCountersForFundraiserListingPage(response.data.data));
        }
        catch {
            console.log("Something went wrong. Didn't get fundraisers count.");
        }
    };
}

function validateFundRaiserTitle(payload) {
    return async dispatch => {
        try {
            const response = await fundraiserAPIs.validateFundraiserTitle(payload);
            dispatch(changePageTitleList(response.data.data));
        }
        catch {
            console.log("Something went wrong. Didn't validate page title.");
        }
    };
}

function fundraiserPagesList(payload) {
    return async dispatch => {
        try {
            const response = await fundraiserAPIs.getFundraisersByUser(payload);
            if (response.data.error) {
                alert(response.data.error);
                return false;
            }
            if (response.data) {
                dispatch(changeUserFundRaiserPageList(response.data.data, payload.page_type));
            }
        }
        catch {
            console.log("Something went wrong.");
        }
    };
}
// --- DO NOT DELETE ---
// function pastfundraiserPagesList(user_id, limit, page_type = 1, page_no = 1) {
//     return dispatch => {
//         let apiEndpoint = 'api/list-past-fr-pages-by-user/' + user_id + '/' + limit + '/' + page_type + '?page=' + page_no;
//         userService.get(apiEndpoint)
//             .then((response) => {
//                 if (response.data.error) {
//                     // alert(response.data.error);
//                     return false;
//                 }
//                 if (response.data.data) {
//                     dispatch(updatePastFundraiserPagesList(response.data.data));
//                 }
//             }).catch((response) => {
//                 return false;
//             })
//     };
// }
// --- DO NOT DELETE ---
// function getTeamMembersListByUser(user_id, limit, is_paginate = 0, page_no = 1) {
//     return dispatch => {
//         let apiEndpoint = 'api/list-tm-by-user/' + user_id + '/' + limit + '/' + is_paginate + '?page=' + page_no;
//         userService.get(apiEndpoint)
//             .then((response) => {
//                 if (response.data.error) {
//                     // alert(response.data.error);
//                     return false;
//                 }
//                 if (response.data.data) {
//                     dispatch(getTeamMembersList(response.data.data));
//                 }
//             }).catch((response) => {
//                 return false;
//             })
//     };
// }
// --- DO NOT DELETE ---
// function recentTeamsFundStat(user_id) {
//     return dispatch => {
//         let apiEndpoint = 'api/recent-teams-stat/' + user_id;
//         userService.get(apiEndpoint)
//             .then((response) => {
//                 if (response.data.error) {
//                     // alert(response.data.error);
//                     return false;
//                 }
//                 if (response.data.data) {
//                     dispatch(getTeamsFundStat(response.data.data));
//                 }
//             }).catch((response) => {
//                 return false;
//             })
//     };
// }

function addUpdatesAsDescriptionOrImages(payload, fundraiser_page_id) {
    return async dispatch => {
        try {
            dispatch(fundRaiserPageAction.updateLoaderState(true));
            const response = await fundraiserAPIs.addUpdatesOnFundraiser(payload);
            dispatch(fundRaiserPageAction.resetInitialState());
            dispatch(fundRaiserPageAction.getFundRaiserPageUpdates(fundraiser_page_id, 1, 0, 6));
            dispatch(addUpdatesAsDescriptionOrImagesInfo(response));
            dispatch(alertActions.success("Your updates are added"));
            dispatch(fundRaiserPageAction.updateLoaderState(false));
        }
        catch {
            console.log("Something went wrong.");
        }
    }
}
function addSocialCount(payload) {
    return async dispatch => {
        try {
            await fundraiserAPIs.addSocialCount(payload);
            dispatch(updateLoaderState(false));
        }
        catch {
            console.log("Something went wrong. Couldn't add social count");
        }
    }
}
function getSocialCount(id) {
    return async dispatch => {
        try {
            const response = await fundraiserAPIs.getSocialCount(id);
            dispatch(changeSocialCountList(response.data.data));
        }
        catch {
            console.log("Something went wrong. Couldn't get the social count");
        }
    };
}

function getFundRaiserPageUpdates(fundraiser_page_id, request_type, offset, limit) {
    return async dispatch => {
        try {
            const response = await fundraiserAPIs.getFundraiserUpdates(fundraiser_page_id, offset, limit);
            if (response.data.data) {
                dispatch(getFundRaiserPageUpdatesList(response.data.data, request_type));
            }
        }
        catch {
            console.log("Something went wrong. Couldn't get the page updates");
        }
    };
}
// --- DO NOT DELETE ---
// function getFundRaiserPageUpdatesImages(fundraiser_page_update_id) {
//     return dispatch => {
//         let apiEndpoint = 'api/get-fundraiser-page-updates-images/' + fundraiser_page_update_id;
//         userService.get(apiEndpoint)
//             .then((response) => {
//                 if (response.data.error) {
//                     // alert(response.data.error);
//                     return false;
//                 }
//                 if (response.data.data) {
//                     let myarr = { update_id: fundraiser_page_update_id, images: response.data.data };
//                     dispatch(getFundRaiserPageUpdatesImagesList(myarr));
//                 }
//             }).catch((response) => {
//                 return false;
//             })
//     };
// }

function getUserDefaultCurrency() {
    return async dispatch => {
        try {
            const response = await userAPIs.getUserCurrency();
            dispatch(changeUserDefaultCurrencyList(response.data.data));
            if (response.data.data && response.data.data.is_exist === true) {
                dispatch(donationActions.checkIfCountryPartnerIsactiveDonor(response.data.data.country_id));
            }
        }
        catch {
            console.log("Something went wrong. Couldn't get the page updates");
        }
    };
}
function resetInitialState() {
    return dispatch => {
        dispatch(resetInitialStateList());
    };
}

function invitationToNewUser(payload) {
    return async dispatch => {
        try {
            const response = await fundraiserAPIs.inviteNewUser(payload);
            if (response && response.data && response.data.success) {
                dispatch(alertActions.success(response.data.success));
            } else if (response && response.data && response.data.error) {
                dispatch(alertActions.error(response.data.error));
            } else {
                console.log("something went wrong.");
            }
        }
        catch {
            console.log("Something went wrong. Couldn't invite the new user");
        }
    };
}

function getTopFundraisersByImpact(page_type, event_id = 0) {
    return dispatch => {
        let apiEndpoint = '';
        if (event_id) {
            apiEndpoint = 'api/get-top-fp-impact/' + page_type + '/' + event_id;
        } else {
            apiEndpoint = 'api/get-top-fp-impact/' + page_type;
        }
        axios.get(apiEndpoint)
            .then((response) => {
                if (response.data && response.data.error) {
                    //alert(response.data.error);
                    // history.push('/not-found');
                    return false;
                }
                if (response.data && response.data.success) {
                    // alert("data found");
                    if (page_type === 1) {
                        dispatch(updateFundraiserImpactedList(response.data.success));
                    } else {
                        dispatch(updateTeamImpactedList(response.data.success));
                    }
                }
            }).catch((response) => {
                return false;
            })
    };
}

function getFundraisersByCampaign(event_id, limit, offset) {
    return async dispatch => {
        try {
            const response = await fundraiserAPIs.getFundraisersByCampaign(event_id, limit, offset)
            if (response.data && response.data.error) {
                window.location.href = WEB_URL.PAGE_NOT_FOUND;
                return false;
            }
            if (response && response.data && response.data.data) {
                dispatch(updateFundraisersByCampaign(response.data.data, offset));
            }
        }
        catch {
            console.log("Something went wrong. Couldn't get fundraisers by campaign");
        }
    };
}

function getCampaignDetails(event_id) {
    return async dispatch => {
        try {
            const response = await fundraiserAPIs.getCampaignDetails(event_id);
            if (response.data && response.data.error) {
                window.location.href = WEB_URL.PAGE_NOT_FOUND;
                return false;
            }
            if (response && response.data && response.data.data) {
                dispatch(updateLoaderState(false));
                dispatch(updateCampaignDetails(response.data.data));
            }
        }
        catch {
            window.location.href = WEB_URL.PAGE_NOT_FOUND;
            console.log("Something went wrong. Couldn't get campaign details");
        }
    };
}

function sendThankyouMessage(payload) {
    return async dispatch => {
        try {
            const response = await fundraiserAPIs.sendThanksToDonor(payload);
            if (response && response.data && response.data.data === true) {
                dispatch(alertActions.success("Message has been sent successfully!"));
            } else {
                console.log("Something went wrong, please try again.");
            }
        }
        catch {
            console.log("Something went wrong. Couldn't send the thank you message");
            dispatch(alertActions.error("Something went wrong"));
        }
    };
}

export function updateCampaignDetails(campaign_details) {
    return {
        type: "CAMPAIGN_DETAILS",
        campaign_details: campaign_details
    }
}

export function updateFundraisersByCampaign(fundraisers_by_campaign, offset) {
    return {
        type: "FUNDRAISERS_BY_CAMPAIGN",
        fundraisers_by_campaign: fundraisers_by_campaign,
        offset
    }
}


export function getFundRaiserPageUpdatesList(page_updates, request_type) {
    return {
        type: "FUNDRAISER_PAGE_UPDATES",
        page_updates: page_updates,
        request_type: request_type
    }
}

export function updateFundraiserImpactedList(top_fundraisers_impacted) {
    return {
        type: "TOP_FUNDRAISERS_IMPACTED",
        top_fundraisers_impacted: top_fundraisers_impacted
    }
}

export function updateTeamImpactedList(top_teams_impacted) {
    return {
        type: "TOP_TEAMS_IMPACTED",
        top_teams_impacted: top_teams_impacted
    }
}

export function resetInitialStateList() {
    return {
        type: "RESET_FUNDRAISER_LIST"
    }
}


export function updateFundraiserPagesList(fundraiser_pages_by_user) {
    return {
        type: "FUNDRAISER_PAGES_BY_USER",
        fundraiser_pages_by_user: fundraiser_pages_by_user
    }
}

export function updatePastFundraiserPagesList(past_fundraiser_pages_by_user) {
    return {
        type: "PAST_FUNDRAISER_PAGES_BY_USER",
        past_fundraiser_pages_by_user: past_fundraiser_pages_by_user
    }
}

export function changeUsersWithoutLeadList(users_except_lead) {
    return {
        type: "GET_ALL_USERS_EXCEPT_FUND_RAISER_PAGE_LEAD",
        users_except_lead: users_except_lead
    }
}


export function changePageTitleList(validate_fd_page_title) {
    return {
        type: "VALIDATE_FUNDRAISER_PAGE_TITLE",
        validate_fd_page_title: validate_fd_page_title
    }
}

export function changeFundRaiserPageList(fundraiser_pages_list, is_search_request) {
    return {
        type: "FETECHED_ALL_FUNDRAISER_PAGES",
        fundraiser_pages_list: fundraiser_pages_list,
        is_search_request: is_search_request
    }
}

export function changeUserFundRaiserPageList(fundraiser_pages_list, pageType) {
    return {
        type: "FUNDRAISER_PAGES_BY_USER",
        data: fundraiser_pages_list,
        pageType

    }
}

export function updateLoaderState(loader_state) {
    return {
        type: "UPDATE_LOADER_STATE",
        loader_state: loader_state
    }
}

export function updateLoaderStateForThankyou(loader_state_thankyou) {
    return {
        type: "UPDATE_LOADER_STATE_THANKYOU",
        loader_state_thankyou: loader_state_thankyou
    }
}

export function changeFundRaiserPageDetail(fundraiser_details) {
    return {
        type: "FUNDRAISER_PAGE_DETAIL",
        fundraiser_details: fundraiser_details
    }
}

export function changeEventIdDetail(event_id) {
    return {
        type: "EVENT_ID",
        event_id: event_id
    }
}

export function changeMinMaxGoalRangeDetail(min_max_range) {
    return {
        type: "GET_MIN_MAX_GOAL_RANGE",
        min_max_range: min_max_range
    }
}

export function changeCampaignsList(campaigns) {
    return {
        type: "FETECHED_ALL_CAMPAIGNS",
        campaigns: campaigns
    }
}

export function changeOccasionsList(occasions) {
    return {
        type: "FETECHED_ALL_OCCASIONS",
        occasions: occasions
    }
}

export function changeFundRaiserDefaultImageList(default_images) {
    return {
        type: "FETECHED_ALL_FUNDRAISER_PAGE_DEFAULT_IMAGES",
        default_images: default_images
    }
}

export function changeCurrenciesList(currencies) {
    return {
        type: "FETECHED_ALL_CURRENCIES",
        currencies: currencies
    }
}

export function changeCountriesList(countries) {
    return {
        type: "FETECHED_ALL_COUNTRIES",
        countries: countries
    }
}

export function countriesWithoutPartners(countries) {
    return {
        type: "FETECHED_ALL_COUNTRIES_WITHOUT_PARTNERS",
        countries_without_partners: countries
    }
}

export function changeCountriesWithCurrenciesList(countries) {
    return {
        type: "FETECHED_ALL_COUNTRIES_WITH_CURRENCIES",
        countries_with_currencies: countries
    }
}

export function handleOnChangeProps(props, value) {
    return {
        type: "HANDLE_ON_CHANGE",
        props: props,
        value: value
    }
}

export function editVendorsDetails(vendor) {
    return {
        type: "VENDOR_DETAIL",
        id: vendor._id,
        name: vendor.name,
        mobile: vendor.mobile,
        phone_number: vendor.phone_number,
        address: vendor.address

    }
}

export function updatedUserInfo() {
    return {
        type: "USER_UPDATED"
    }
}

export function createFundRaiserInfo() {
    return {
        type: "FUNDRAISER_PAGE_CREATED_SUCCESSFULLY"
    }
}

export function createTeamMemberInfo() {
    return {
        type: "TEAM_MEMBERS_WAS_CREATED_SUCCESSFULLY"
    }
}

export function updateTeamMembers(team) {
    return {
        type: "UPDATE_TEAM",
        team
    }
}

export function changeTeamMembersList(team) {
    return {
        type: "FETECHED_ALL_TEAM_MEMBERS",
        team: team
    }
}

export function changeTeamMembersPaginationList(team) {
    return {
        type: "FETECHED_ALL_TEAM_MEMBERS_WITH_PAGINATION",
        team: team
    }
}

export function changeTeamMembersListCount(team_count) {
    return {
        type: "FETECHED_ALL_TEAM_MEMBERS_COUNT",
        team_count: team_count
    }
}

export function changeDonationsListCount(donations_count) {
    return {
        type: "FETECHED_FUNDRAISER_DONATIONS_COUNT",
        donations_count: donations_count
    }
}

export function changeCountersForFundraiserListingPage(listing_page_counts) {
    return {
        type: "FETECHED_FUNDRAISER_LISTING_PAGE_COUNTS",
        listing_page_counts: listing_page_counts
    }
}

export function allTeamMembersList(active_team_members) {
    return {
        type: "FETECHED_ACTIVE_TEAM_MEMBERS",
        active_team_members: active_team_members
    }
}

export function TeamMemberList(team_member) {
    return {
        type: "FETECHED_TEAM_MEMBER",
        team_member: team_member
    }
}

export function changeFundRaiserPageDonorList(donors) {
    return {
        type: "FETECHED_ALL_FUNDRAISER_PAGE_DONORS",
        donors: donors
    }
}

export function changeFundRaiserPageMonstRecentDonations(donors, offset) {
    return {
        type: "FETECHED_ALL_FUNDRAISER_PAGE_MOST_RECENT_DONATIONS",
        donors: donors,
        offset
    }
}

export function changeFundRaiserPageMonstDonations(donors, offset) {
    return {
        type: "FETECHED_ALL_FUNDRAISER_PAGE_MOST_DONATIONS",
        donors: donors,
        offset
    }
}

export function deleteVendorsDetails() {
    return {
        type: "DELETED_VENDOR_DETAILS"
    }
}

export function getTeamMembersList(team_members_by_user) {
    return {
        type: "TEAM_MEMBERS_BY_USER",
        team_members_by_user: team_members_by_user
    }
}

export function getTeamsFundStat(recent_teams_stat) {
    return {
        type: "RECENT_TEAMS_STAT",
        recent_teams_stat: recent_teams_stat
    }
}
export function addUpdatesAsDescriptionOrImagesInfo(cover_images) {
    return {
        type: "ADD_UPDATES_AS_DESCRIPTION_OR_IMAGES",
        cover_images: cover_images
    }
}
export function getFundRaiserPageUpdatesImagesList(page_updates_images) {
    return {
        type: "FUNDRAISER_PAGE_UPDATES_IMAGES",
        page_updates_images: page_updates_images
    }
}


export function changeUserDefaultCurrencyList(location_details) {
    return {
        type: "FETECHED_USER_DEFAULT_CURRENCY",
        location_details: location_details
    }
}

export function changeSocialCountList(social_count) {
    return {
        type: "FETECHED_FUNDRAISER_SHARE_COUNT",
        social_count: social_count
    }
}

export function intimateFundraierPageCreation(status) {
    return {
        type: "INTIMATE_FUNDRAISER_PAGE_CREATION",
        status: status
    }
}

export const fundRaiserPageAction = {
    getGoodLuckMessages,
    getFundRaiserPage,
    onChangeProps,
    createFundRaiserPage,
    getListOfCampaigns,
    getListOfOccasions,
    getListOfCurrencies,
    validateFundRaiserTitle,
    fetchUsersToInvite,
    createTeamMember,
    getListOfTeamMembers,
    getListOfFundraiserPageDonors,
    updateFundRaiserPage,
    fundraiserPagesList,
    getProducts,
    // getTeamMembersListByUser,
    // recentTeamsFundStat,
    getListOfCountries,
    getAllFundRaiserPages,
    // pastfundraiserPagesList,
    getListOfCountriesWithCurrencies,
    getEventId,
    updateLoaderState,
    removeTeamMember,
    // getActiveTeamMembers,
    addUpdatesAsDescriptionOrImages,
    getFundRaiserPageUpdates,
    // getFundRaiserPageUpdatesImages,
    getListOfTeamMembersCount,
    getFundraiserRecentDonations,
    getFundraiserMostDonated,
    getListOfTeamMembersWithPagination,
    getDonationCount,
    getTeamMemberDetails,
    getFundRaiserPageDefaultImages,
    getFundraisersCount,
    getUserDefaultCurrency,
    addSocialCount,
    getSocialCount,
    resetInitialState,
    getMinMaxGoalRange,
    intimateFundraierPageCreation,
    invitationToNewUser,
    getTopFundraisersByImpact,
    getFundraisersByCampaign,
    getCampaignDetails,
    // newUserAlreadyExists,
    getListOfCountriesWithoutPartners,
    updateLoaderStateForThankyou,
    sendThankyouMessage
};